// extracted by mini-css-extract-plugin
export default {"svg":"StateTimelineChart_svg__k+TIw"};